import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react'
import { WagmiConfig } from 'wagmi'
import { avalancheFuji , bsc} from '@wagmi/core/chains'
import { ReactSession } from 'react-client-session';
 

const projectId = '30bb3b83e31c8d6b38bd3bae99605a41'


const chains = [bsc]

const wagmiConfig = defaultWagmiConfig({ chains, projectId })

createWeb3Modal({ wagmiConfig, projectId, chains })

const root = ReactDOM.createRoot(document.getElementById('root'));

ReactSession.setStoreType("localStorage");

if(ReactSession.get("refwallet") == undefined){
  ReactSession.set("refwallet","0x0000000000000000000000000000000000000000");
}
root.render(
  <React.StrictMode>
    <WagmiConfig config={wagmiConfig}>
        <App />
     </WagmiConfig>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
